import React from 'react';
import { Field } from 'redux-form';
import { SelectInput, SelectArrayInput } from 'react-admin';

import CommonSettings from '../../../../Common/Partials/Settings';
import { domainsDropdown } from '../../StaticData/Domains';
import PaceInputs from '../../../../Common/Partials/PaceInputs';
import Priorities from '../StaticData/Priorities';

type Props = {
  permissions: any,
  record: any,
  resource: string
};

const SettingsTab = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <CommonSettings
      permissions={props.permissions}
      record={props.record}
      resource={props.resource} />

    <div style={{ display: 'flex', paddingTop: 20 }}>
      <div style={{ flex: 1, paddingRight: 15 }}>
        <PaceInputs />
      </div>
      <div style={{ flex: 1, paddingLeft: 15 }}>
        <Field
          choices={Priorities}
          component={SelectInput}
          label="Priority"
          name="priority"
          source="priority" /><br />
        <Field
          choices={domainsDropdown()}
          component={SelectArrayInput}
          label="End Points"
          name="domains"
          source="domains" /><br />
      </div>
    </div>
  </div>
);

export default SettingsTab;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/AdTag/Partials/SettingsTab.tsx